
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { PrestoLinkedService } from 'app/model/linkedservice/presto.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.presto.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Presto_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Presto_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: PrestoLinkedService.MODEL // Linked service redefined
        }
    }
})
export class PrestoObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
